var TagFilter = React.createClass({
  propTypes: {
    tags: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    selectedTagIDs: React.PropTypes.arrayOf(React.PropTypes.number).isRequired,
    onTagsChanged: React.PropTypes.func
  },
  getDefaultProps() {
    return {
      selectedTagIDs: []
    }
  },
  tagClicked(tagID) {
    let selectedTagIDs = this.props.selectedTagIDs;

    if (this.isTagSelected(tagID)) {
      selectedTagIDs = selectedTagIDs.filter(id => id != tagID);
    } else {
      selectedTagIDs.push(tagID);
    }

    if (this.props.onTagsChanged) {
      this.props.onTagsChanged(selectedTagIDs);
    }
  },
  resetSelectedTags() {
    if (this.props.onTagsChanged) {
      this.props.onTagsChanged([]);
    }
  },
  isTagSelected(id) {
    return this.props.selectedTagIDs.indexOf(id) > -1;
  },
  getItem(tag) {
    let className = classNames("filter__item", {"-active": this.isTagSelected(tag.id)});

    return (
      <li className={className} key={tag.id}>
        <a href="#" className="filter__link" onClick={this.tagClicked.bind(this, tag.id)}>{tag.tag}</a>
      </li>
    )
  },
  getClearLink() {
    if (this.props.selectedTagIDs.length == 0) return;

    return (
      <ul className="filter__list">
        <li className="filter__item">
          <a href="#" onClick={this.resetSelectedTags}>{Labels.getLabel("Clear")}</a>
        </li>
      </ul>
    )
  },
  render() {
    if (this.props.tags.length == 0) {
      return <span />
    }

    let items = this.props.tags.map(this.getItem);

    return (
      <BrowseFilter title={Labels.getLabel("Tags")}>
        {this.getClearLink()}

        <CollapsingFilterList
          items={items}
          listClassName="filter__list -tags"
          displayBeforeFold={10} />

      </BrowseFilter>
    )
  }
});